export const marketplaceTypes = {
    addOneOfOne: '[Marketplace] adds a one of one',
    updateOneOfOne: '[Marketplace] modifies an existing one of one',
    removeOneOfOne: '[Marketplace] removes an existing one of one',
    setErrorOnOneOfOnes: '[Marketplace] sets error to true for one of ones',
    addWearable: '[Marketplace] adds a wearable',
    resetMarketplace: '[Marketplace] resets the one of ones',
    getPhases: '[Marketplace] gets all phases',
    setActivePhase: '[Marketplace] sets the active phase'
}